// extracted by mini-css-extract-plugin
export default {"service":"Cookie_service__5fbKx"};